export default __webpack_public_path__ + "096a08ded9a185d8fe61956498e1b676.png";